const c = {
  name: "HandsPeace",
  dimensions: { width: 29, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 29 39.9" style="enable-background:new 0 0 29 39.9;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.2,13.7L7.9,6.2l0,0C7.5,4,5.5,2.6,3.3,3C1.1,3.4-0.3,5.5,0.1,7.7L3,24.3v2.6c0,7.2,5.8,13,13,13
			c7.2,0,13-5.8,13-13v-9c0-2.2-1.8-4-4-4c-0.8,0-1.6,0.2-2.2,0.7c-0.5-1.6-2-2.7-3.8-2.7c-0.5,0-0.9,0.1-1.4,0.2L19,4.7
			c0.4-2.2-1.1-4.3-3.2-4.6l0,0c-2.2-0.4-4.3,1.1-4.6,3.2L9.2,13.7z M10.3,18.9L13,3.7c0.2-1.1,1.2-1.8,2.3-1.6
			c1.1,0.2,1.8,1.2,1.6,2.3l-2.6,14.8c-0.4-0.2-0.9-0.2-1.4-0.2H10.3z M3.6,5C4.7,4.8,5.8,5.5,6,6.6l2.2,12.3H7
			c-1.1,0-2,0.4-2.7,1.1L2,7.4l0,0C1.8,6.2,2.6,5.1,3.6,5L3.6,5z M13,24.9H9v2h4c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4
			c1.7,0,3.2-1.1,3.8-2.7c0.6,0.4,1.4,0.7,2.2,0.7c0.7,0,1.4-0.2,2-0.5v2.5c0,6.1-4.9,11-11,11S5,33,5,26.9v-4c0-1.1,0.9-2,2-2h6
			c1.1,0,2,0.9,2,2C15,24,14.1,24.9,13,24.9z M19,13.9c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2v-7
			C17,14.8,17.9,13.9,19,13.9z M25,22.9c-1.1,0-2-0.9-2-2v-3c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v3C27,22,26.1,22.9,25,22.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as HandsPeace
};
